import { useContext } from 'react';
import CurrentSiteContext from '../contexts/CurrentSiteContext';

const useCurrentSite = () => (
  useContext(CurrentSiteContext)
);

export default useCurrentSite;
